// extracted by mini-css-extract-plugin
export default {"logo":"Sider_logo__o-TNj","collapsed":"Sider_collapsed__5QJAH","sider":"Sider_sider__mBQpq","menu":"Sider_menu__GFC6s"};